import { PRODUCT_TYPES } from '~/common/utils/product/constants'
import { useCMSGlobalSettingsStore } from '~/store'
import { MappedProduct } from '~/types/product/productTypes'

export function isSignalStarAntibodyKit(product: MappedProduct) {
  const { getAttributeByCountry } = useCMSGlobalSettingsStore()
  const signalStarSecondaryAntibodyKits = getAttributeByCountry('signalStarSecondaryAntibodyKits').value

  return (
    product.productType === PRODUCT_TYPES.OLIGO_ANTIBODY_PAIR && signalStarSecondaryAntibodyKits.includes(product.key)
  )
}
